import React from "react";

const Kotlin_Operators = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin Operators</h1>
      <p>Content for Kotlin Operators goes here.</p>
    </div>
  );
};

export default Kotlin_Operators;
